import { SimpleEntityActions } from '@app/classes';
import { ModelMixin } from '../core/base-generic.model';

export class FlinksConnect extends ModelMixin<FlinksConnect>() {
    protected static _resource = 'companyManagement/companies/:company/bankAccounts/flinksConnect';

    protected static _type = 'flinksConnects';

    protected static _version = 'v2';

    protected static _serializeAttributes = ['companyId', 'bankAccountId', 'flinksLoginId', 'flinksAccountId'];

    // Same permissions as bank account
    static permission = new SimpleEntityActions('bankAccount');

    get companyId(): number {
        return this._attributes['companyId'];
    }
    get bankAccountId(): number {
        return this._attributes['bankAccountId'];
    }

    /**
     * Flinks Login
     */
    get flinksLoginId(): string {
        return this._attributes['flinksLoginId'];
    }
    set flinksLoginId(val: string) {
        this._attributes['flinksLoginId'] = val;
    }
    /**
     * Flinks account
     */
    get flinksAccountId(): string {
        return this._attributes['flinksAccountId'];
    }
    set flinksAccountId(val: string) {
        this._attributes['flinksAccountId'] = val;
    }
}
